module.exports = __webpack_public_path__ + "img/user-avatar.b8982e19.png";